import React from "react";
import DeviceDetector from 'device-detector-js';
import { ErrorBoundary } from "react-error-boundary";

import ExceptionScreen from "./pages/Guest/NoMatch/ExceptionScreen";
import regsiterApi from "./actions/registerapi";


export default function ExceptionHandler({ children }) {

    const deviceDetector = new DeviceDetector();
    const deviceDetails = deviceDetector.parse(navigator.userAgent);

    const handleError = (error) => {
        const errorData = {
            message: error.message,
            stacktrace: error.stack,
            device_details: JSON.stringify(deviceDetails),
            url: window.location.pathname,
        }
        regsiterApi.post('/errors', errorData)
    };

    return (
        <ErrorBoundary
            FallbackComponent={({ resetErrorBoundary }) => (
                <ExceptionScreen onClick={resetErrorBoundary} />
            )}
            onError={handleError}
        >
            {children}
        </ErrorBoundary>
    )
}